//@flow
export const TIENDADA_LINKS = {
  customerSupport: {
    general:
      'https://api.whatsapp.com/send/?phone=51972076020&text=¡Hola!+Necesito+soporte+con+mi+TiendaDA.+Mi+dominio+es&type=phone_number&app_absent=0',
    consultancy:
      'https://calendly.com/naomi-tiendada/capacitacion-tiendada-clone',
  },
  tutorials: {
    GENERAL: 'https://tiendada.tawk.help/category/tutoriales-y-gu%C3%ADas',
    ORDERS: 'https://tiendada.tawk.help/article/¿cómo-gestiono-mis-pedidos',
    PRODUCTS: 'https://tiendada.tawk.help/category/tutoriales-y-guías',
    COUPONS:
      'https://tiendada.tawk.help/article/¿cómo-crear-cupones-de-descuento',
    PROMOTIONS: 'https://tiendada.tawk.help/article/¿cómo-crear-promociones',
    REVIEWS:
      'https://tiendada.tawk.help/article/¿cómo-visualizar-reseñas-de-tus-clientes',
    TEMPLATES: 'https://tiendada.tawk.help/',
    PERSONAL_INFORMATION:
      'https://tiendada.tawk.help/article/¿puedo-configurar-mi-información-personal',
    STORE_DESIGN:
      'https://tiendada.tawk.help/article/¿cómo-configurar-el-diseño-de-mi-tiendada',
    PAYMENT_METHODS:
      'https://tiendada.tawk.help/article/¿cómo-configurar-métodos-de-pago',
    SHIPPING:
      'https://tiendada.tawk.help/article/¿cómo-configurar-tarifas-de-envío',
    SALES_PROCESS:
      'https://tiendada.tawk.help/article/¿cómo-puedo-editar-los-mensajes-de-seguimiento-por-el-cambio-de-estado-de-un-pedido',
    COLLABORATORS:
      'https://tiendada.tawk.help/article/¿puedo-agregar-uno-o-más-usuarios-a-mi-tiendada',
    CRM:
      'https://tiendada.tawk.help/article/¿con-tiendada-puedo-manejar-una-base-de-datos-de-mis-clientes',
    PAGES: 'https://tiendada.tawk.help/category/tutoriales-y-guías',
    CUSTOM_DOMAIN:
      'https://tiendada.tawk.help/article/¿cómo-configurar-mi-dominio-propio',
    SOCIAL_MEDIA: 'https://tiendada.tawk.help/category/tutoriales-y-guías',
    BLOG:
      'https://tiendada.tawk.help/article/¿puedo-crear-un-blog-en-mi-tiendada',
    GOOGLE: 'https://tiendada.tawk.help/article/google-analytics',
    FACEBOOK_PIXEL:
      'https://tiendada.tawk.help/article/¿cómo-configurar-el-píxel-de-facebook',
    MULTICHAT:
      'https://tiendada.tawk.help/article/configura-tu-canal-de-comunicación',
    TAX_INVOICE: 'https://www.youtube.com/watch?v=ChHZyjebO4A',
    BULK_PRODUCT_UPLOAD_AND_EDIT:
      'https://tiendada.tawk.help/article/%C2%BFc%C3%B3mo-cargar-un-producto-manualmente',
    PRODUCT_OPTIONS: 'https://tiendada.tawk.help/article/opciones-de-productos',
  },
  youtube: {
    main_channel: 'https://www.youtube.com/@tiendada',
  },
  adHocService:
    'https://tiendadateam.notion.site/Potencia-tu-Tienda-con-Add-ons-Mensuales-2d2d823ae861807e8713fec0f327570f?pvs=74',
};
